const UtmTracking = () => {
  // URL parameters to watch and track for in Gravity Forms/COINS
  const COINS_PARAMS = [
    'gclid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'fbclid',
  ];
  // Cookie prefix
  const COOKIE_PREFIX = 'lead_';
  // Cookie expiry days
  const EXP_DAYS = 90;

  // Debugging switch
  const DEBUG = false;

  // Logging function for all tracking params/functionality
  function log(...args) {
    console.log('[UtmTracking]', ...args);
  }

  // Setter function
  function setCookie(name, value) {
    const d = new Date();
    d.setTime(d.getTime() + EXP_DAYS * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(
      value,
    )};expires=${d.toUTCString()};path=/;SameSite=Lax`;
    log('Set cookie:', name, '=', value);
  }

  // Getter function
  function getCookie(name) {
    const n = `${name}=`;
    const decoded = decodeURIComponent(document.cookie);
    const ca = decoded.split(';');
    for (let c of ca) {
      c = c.trim();
      if (c.indexOf(n) === 0) return c.substring(n.length);
    }
    return null;
  }

  // Function to detect the source of the visit
  function detectSource(params) {
    if (params.gclid) {
      return 'Google';
    }
    if (params.fbclid) {
      return 'Meta';
    }
    if (params.utm_source) {
      return params.utm_source;
    }
    return null;
  }

  // Function to process parameters in the URL that we want to track
  function processParams() {
    // The current URL
    const url = new URL(window.location.href);
    // Object to hold found matching parameters
    const newParams = {};
    // Boolean to store whether or not we matched any URL parameters
    let paramsMatched = false;

    // Loop through each parameter we want to track
    COINS_PARAMS.forEach((param) => {
      const trackingValue = url.searchParams.get(param);

      // If this parameter is set
      if (trackingValue) {
        // Save the value
        newParams[param] = trackingValue;
        // Switch the toggle to run the cookie save part of the code
        paramsMatched = true;
      }
    });

    // If no matching params were found, skip running the rest of the code
    if (!paramsMatched) {
      return;
    }

    // Check the source of the user
    const source = detectSource(newParams);
    // Check if the user has already visited the website and a "source" was saved
    const firstSource = getCookie(`${COOKIE_PREFIX}first_source`);

    // If we have a source and no previous source
    if (!firstSource && source) {
      // Save the new source as the "first source" cookie
      setCookie(`${COOKIE_PREFIX}first_source`, source);
      if (DEBUG) {
        log('First source set to:', source);
      }
    }

    // If we have a source - also update the last source cookie
    if (source) {
      setCookie(`${COOKIE_PREFIX}last_source`, source);
      if (DEBUG) {
        log('Last source updated to:', source);
      }
    }

    // Save all other matching parameters as cookie values
    Object.entries(newParams).forEach(([key, value]) => {
      setCookie(COOKIE_PREFIX + key, value);
    });
  }

  // Trigger that fires all of the tracking code
  function initTracking() {
    // Check that cookiebot is active on the website
    if (!window.Cookiebot) {
      if (DEBUG) {
        console.warn('[UtmTracking] Cookiebot not available.');
      }
      return;
    }

    if (DEBUG) {
      log('Cookiebot detected, checking consent...');
    }

    // Check if the user has accepted the marketing cookies
    function runIfMarketingAllowed() {
      if (window.Cookiebot?.consent?.marketing) {
        if (DEBUG) {
          log('Marketing consent granted.');
        }
        // If so, process any URL parameters
        processParams();
      } else if (DEBUG) {
        log('Marketing consent not granted.');
      }
    }

    // Runs when consent state becomes available
    window.addEventListener('CookiebotOnConsentReady', runIfMarketingAllowed);

    // Runs when the user accepts cookies
    window.addEventListener('CookiebotOnAccept', runIfMarketingAllowed);
  }

  // Async function which keeps watching for CookieBot, in case the loading is delayed/the user doesn't immediately
  // accept or deny cookies via the banner/widget
  function waitForCookiebot(retries = 30) {
    if (window.Cookiebot) {
      initTracking();
      return;
    }

    if (retries > 0) {
      setTimeout(() => waitForCookiebot(retries - 1), 250);
    } else if (DEBUG) {
      console.warn('[UtmTracking] Cookiebot never became available.');
    }
  }

  document.addEventListener('DOMContentLoaded', () => waitForCookiebot());
};

export default UtmTracking;
